import { ServiceDetailPage } from '../../components/ServiceDetailPage';
import { SERVICE_NYELVLOKES } from '../../data/content';
import { Helmet } from 'react-helmet-async';

export default function TongueThrustPage() {
  return (
    <>
      <Helmet>
        <title>Nyelvlökéses Nyelés Terápia | Mosolytorna Dunakeszi</title>
        <meta name="description" content="Nyelvlökéses nyelés és fogszabályozást támogató logopédiai terápia, a helyes nyelés és a megfelelő nyugalmi nyelvpozíció kialakítása." />
      </Helmet>
      
      <ServiceDetailPage service={SERVICE_NYELVLOKES} />
    </>
  );
}
